<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-07",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 59,
      nextPage: '/questionnaire/section4/8',
      navigateType: 'INPUT_SUBMIT',
      content: {
        mainTitle: 'Your Email?',
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // 只限制前进 允许返回
    if(to.path !== '/questionnaire/section4/8'){
      next()
    }else{
      const emailReg = /^[A-Za-z0-9-._]+@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,6})$/;
      const email = this.$store.state.qsData[this.qsNumber].input
      if(emailReg.test(email)){
        this.$store.commit({
          type: 'addUserEmail',
          email: this.$store.state.qsData[this.qsNumber].input
        })

        // 设置用户属性
        this.$sensors.setProfile({
          FFQSemail: this.$store.state.qsData[this.qsNumber].input
        })
        
        next()
      }else{
        window.confirm('Please fill in the correct email address')
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
